import { emptyValidator, formValidator, mobilePhoneMenValidator, mobilePhoneNotMenValidator } from "../../validators";

const jobContainerValidationStatus = {
  // jcoContainerType: {
  //   validators: [emptyValidator()],
  //   name: "Container Type",
  // },
  // jcoTrailer: {
  //   validators: [emptyValidator()],
  //   name: "Trailer",
  // },
  jcoContainerNumber: {
    validators: [emptyValidator()],
    name: "Container Number",
  },
  // jcoTrailerNumber: {
  //   validators: [emptyValidator()],
  //   name: "Trailer Number",
  // },
};

export const jobContainerValidation = (jobContainer) => {
  return formValidator(jobContainer, jobContainerValidationStatus);
};

const vehicleAssignmentValidationStatus = {
  jobVehicle: {
    validators: [emptyValidator()],
    name: "Vehicle",
  },
  jobDriver: {
    validators: [emptyValidator()],
    name: "Driver",
  },

  jobAdditionalDriverMobile: {
    validators: [mobilePhoneNotMenValidator()],
    name: "Additional Mobile Number",
  },
};

export const vehicleAssignmentValidation = (vehicleAssignment) => {
  return formValidator(vehicleAssignment, vehicleAssignmentValidationStatus);
};
